exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header.bg-dark[data-v-61ad9207]{background-color:#f6f7f7!important;color:#000!important;padding:5px 10px}.filter-title[data-v-61ad9207]{position:relative;width:60px;height:60px;display:block;line-height:60px;-moz-border-radius:30px;border-radius:30px;background-color:#000;color:#fff;text-align:center;font-size:2em;margin-left:50px;margin-top:20px}.card-body[data-v-61ad9207]{min-height:150px}@media screen and (max-width:768px){.card[data-v-61ad9207]{margin-left:5px!important;width:185px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61ad9207","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/filter/displayers/display-location.vue
// module id = 1696
// module chunks = 0